<template>
  <v-container fluid>
    <!-- {{ getParams() }} -->
    <v-row no-gutters>
      <v-col>
        <v-card flat width="20%">
          <v-card-text>
            <v-menu ref="fechaDialogReporte" v-model="modalFechas" :close-on-content-click="false" :nudge-right="-17"
              transition="scale-transition" offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field dense v-model="selectedRangueFecha" label="Días" prepend-icon="mdi-calendar" readonly
                  v-bind="attrs" v-on="on"></v-text-field>
              </template>
              <v-date-picker :selected-items-text="'$vuetify.datePicker.itemsSelected'" locale="es" width="240" no-title
                scrollable v-model="dialogVarSelectedRangueFecha" range :max="disabledFecha" color="primary"
                header-color="primary">
                <v-spacer></v-spacer>
                <!-- <v-btn text color="primary" @click="setModalFechas(false)">
                  Cancelar
                </v-btn> -->
                <v-btn text color="primary" @click="saveDateRange(dialogVarSelectedRangueFecha), setModalFechas(false)">
                  cerrar
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-data-table disable-pagination :options.sync="options" :hide-default-footer="true" :headers="headers"
      :items="items">
      <template v-slot:top>
        <v-row no-gutters>
          <v-spacer>

          </v-spacer>
          <v-btn x-small @click="items = [], applyFilters()" class="mt-3 ml-1 mr-1 flo" color="primary">
            <v-icon small>mdi-refresh</v-icon>
          </v-btn>
          <v-btn x-small @click="applyFilters" class="mt-3 ml-1 mr-1 flo" color="primary">
            Búscar
          </v-btn>

          <v-btn :loading="loading" x-small @click="exportToExcel" class="mt-3 ml-1 mr-1 flo" color="success">
            Exportar a Excel
          </v-btn>
          <v-btn :loading="loading" x-small @click="exportToPDF" class="mt-3 ml-1 mr-1 flo" color="success">
            Exportar a PDF
          </v-btn>
        </v-row>
      </template>
      <template v-slot:header>
        <tr>
          <td v-for="header in filteredHeaders" :key="header.value">
            <div v-if="header.type === 'blank'"></div>
            <v-text-field @keydown.enter="applyFilters()" dense v-if="header.type === 'date'"
              v-model="filters[header.value]" :label="`${header.text}`" hide-details solo></v-text-field>
            <v-text-field @keydown.enter="applyFilters()" dense v-if="header.type === 'string'"
              v-model="filters[header.value]" :label="`${header.text}`" hide-details solo></v-text-field>
            <v-text-field @keydown.enter="applyFilters()" dense v-if="header.type === 'integer'" type="number" step="1"
              v-model.number="filters[header.value]" :label="`${header.text}`" hide-details solo></v-text-field>
            <v-select @change="applyFilters()" clearable dense v-if="header.type === 'boolean'"
              v-model="filters[header.value]" :items="booleanOptions" :label="`${header.text}`" hide-details
              solo></v-select>
            <!-- Add other input types as needed -->
          </td>
        </tr>

      </template>
      <template v-slot:[`item.nombre`]="{ item }">
        {{ item.primer_nombre }} {{ item.segundo_nombre }}
        {{ item.tercer_nombre }} {{ item.primer_apellido }}
        {{ item.segundo_apellido }} {{ item.tercer_apellido_o_casada }}
      </template>
      <template v-slot:[`item.createdAt`]="{ item }">
        {{ fnGetDateTime(item.createdAt) }}
      </template>
      <template v-slot:[`item.flag_precalificacion_completada_fecha`]="{ item }">
        {{ fnGetDateTime(item.flag_precalificacion_completada_fecha) }}
      </template>
      <template v-slot:[`item.campania`]="{ item }">
        {{ item.campania }}
      </template>
      <template v-slot:[`item.resultado_evaluacion_equifax_tiempo`]="{ item }">
        <span v-if="item.resultado_evaluacion_equifax_tiempo">{{ item.resultado_evaluacion_equifax_tiempo2 }}</span>
        <span v-else>-</span>

      </template>
      <template v-slot:[`item.flag_precalificacion_en_revision_fecha`]="{ item }">
        {{ fnGetDateTime(item.flag_precalificacion_en_revision_fecha) }}
      </template>
      <template v-slot:[`item.fecha_fin_gestion`]="{ item }">
        {{ fnGetDateTime(item.fecha_fin_gestion) }}
      </template>
      <template v-slot:[`item.flag_precalificacion_concluidas_fecha`]="{ item }">
        {{ fnGetDateTime(item.flag_precalificacion_concluidas_fecha) }}
      </template>
      <template v-slot:[`item.compromisos_de_pago`]="{ item }">
        <p v-if="!item.compromisos_de_pago">--</p>
        <span v-else v-html="formatResumenContratoHTML(resumirContrato(item.compromisos_de_pago))"> </span>
      </template>
      <template v-slot:[`item.flag_tiene_pedido`]="{ item }">
        <span v-if="item.flag_tiene_pedido == 1">Si</span>
        <span v-if="item.flag_tiene_pedido != 1">No</span>
      </template>
      <template v-slot:[`item.resultado_evaluacion`]="{ item }">
        <v-chip small dark :color="item.resultado_evaluacion_color">{{ item.resultado_evaluacion_color_esp }}</v-chip>
      </template>
    </v-data-table>
    <v-row>
      <!-- PAGINACIÓN -->
      <v-col cols="12">
        <v-col offset="9" cols="3">
          <v-select v-model="pageSize" :items="pageSizes" label="Registros por página"
            @change="handlePageSizeChange"></v-select>
        </v-col>
        <v-col class="">
          Total de registros: {{ totalRegistros }}
          <v-pagination class="float-right" v-model="page" :length="totalPages" total-visible="15"
            next-icon="mdi-menu-right" prev-icon="mdi-menu-left" @input="handlePageChange"></v-pagination>
        </v-col>
      </v-col>
      <!-- FIN PAGINACIÓN -->
    </v-row>
  </v-container>
</template>
<script>
import moment from 'moment';
require('moment/locale/es.js');
import { mapActions, mapGetters } from 'vuex';

import jsPDF from 'jspdf';
import 'jspdf-autotable';

export default {
  data() {
    return {
      loading: false,
      //
      booleanOptions: [
        { text: 'Sí', value: 1 },
        { text: 'No', value: 0 },
      ],
      //pagination
      options: {},
      page: 1,
      totalPages: 0,
      pageSize: 10,
      pageSizes: [10, 25, 50, 100],
      totalRegistros: 0,
      //pagination fin
      headers: [
        { text: 'Gestión ID', value: 'id', type: 'integer', width: 90 },
        {
          text: 'Nombre completo',
          value: 'deudor_nombre_completo',
          type: 'string',
          width: 185
        },
        {
          text: 'Estado',
          value: 'estado',
          type: 'string',
          width: 180
        },
        {
          text: 'Campaña',
          value: 'campania',
          type: 'string',
          width: 155
        },
        {
          text: 'Fecha de creación',
          value: 'createdAt',
          type: 'date',
          width: 175
        },
        {
          text: 'Fecha carga completa de documentos y referencias',
          value: 'flag_precalificacion_completada_fecha',
          type: 'date',
          width: 175
        },
        {
          text: 'Fecha Inicio Gestión',
          value: 'flag_precalificacion_en_revision_fecha',
          type: 'date',
          width: 170
        },
        {
          text: 'Fecha Fin Gestión',
          value: 'fecha_fin_gestion',
          type: 'date',
          width: 175
        },
        {
          text: 'Sector',
          value: 'sector',
          type: 'integer',
          width: 155
        },
        /** */
        {
          text: 'Tiempo Evaluación EQUIFAX',
          value: 'resultado_evaluacion_equifax_tiempo',
          type: 'integer',
          width: 155
        },
        /**llenado desde la APP */
        {
          text: 'Tiempo Carga Expediente',
          value: 'tiempo_llenado_evaluacion2',
          type: 'string',
          width: 155
        },
        /** */

        {
          text: 'Tiempo Creación Gestión para verificación',
          value: 'tiempo_creacion_gestion2',
          type: 'string',
          width: 155
        },
        {
          text: 'Tiempo Revisión Gestión verificación',
          value: 'tiempo_de_revision_de_complementos2',
          type: 'string',
          width: 155
        },
        /** computados */
        {
          text: 'tiempo rectificación contrato',
          value: 'tiempo_rectificaciones_contrato',
          type: 'string',
          width: 170
        },
        {
          text: 'tiempo rectificación documentos',
          value: 'tiempo_rectificaciones_documentos',
          type: 'string',
          width: 155
        },
        {
          text: 'tiempo rectificación referencias',
          value: 'tiempo_rectificaciones_referencias',
          type: 'string',
          width: 155
        },
        {
          text: 'tiempo rectificación contrato compromiso de pago',
          value: 'tiempo_compromiso_pago_contrato',
          type: 'string',
          width: 155
        },
        {
          text: 'tiempo rectificación documentos compromiso de pago',
          value: 'tiempo_compromiso_pago_documentos',
          type: 'string',
          width: 155
        },
        {
          text: 'tiempo rectificación referencias compromiso de pago',
          value: 'tiempo_compromiso_pago_referencias',
          type: 'string',
          width: 155
        },
        /**no computado */
        {
          text: 'Tiempo Total Rectificación',
          value: 'tiempo_total_rectificacion',
          type: 'string',
          width: 155
        },


        {
          text: 'Tiempo Total verificación',
          value: 'tiempo_total_verificacion2',
          type: 'string',
          title: 'Tiempo total desde inicio de revision, hasta que ha sido aprobada',
          width: 155
        },
        {
          text: 'Tiempo aprobación gestión verificación',
          value: 'tiempo_total_aprobacion',
          type: 'string',
          width: 155
        },
        /** computado */
        {
          text: 'Tiempo Total venta',
          value: 'tiempo_transcurrido_total',
          type: 'string',
          width: 155
        },
        {
          text: 'Documentos a rectificar',
          value: 'eventos',
          type: 'string',
        },
        { text: 'Comentario movil motivo de eliminación', value: 'flag_precalificacion_eliminada_motivo', type: 'string', width: 180 },


        // Add other headers with types
      ],
      items: [],
      filters: {
        id: '',
        deudor_nombre_completo: '',
        estado: '',
        campania: '',
        createdAt: '',
        flag_precalificacion_completada_fecha: '',
        flag_precalificacion_en_revision_fecha: '',
        fecha_fin_gestion: '',
        sector: '',
        resultado_evaluacion_equifax_tiempo: '',
        tiempo_llenado_evaluacion2: '',
        tiempo_creacion_gestion2: '',
        tiempo_de_revision_de_complementos2: '',
        tiempo_rectificaciones_contrato: '',
        tiempo_rectificaciones_documentos: '',
        tiempo_rectificaciones_referencias: '',
        tiempo_compromiso_pago_contrato: '',
        tiempo_compromiso_pago_documentos: '',
        tiempo_compromiso_pago_referencias: '',
        tiempo_total_rectificacion: '',
        tiempo_total_verificacion2: '',
        tiempo_total_aprobacion: '',
        tiempo_transcurrido_total: '',
        eventos: '',
        flag_precalificacion_eliminada_motivo: '',
      },
      filterConfig: {
        id: true,
        deudor_nombre_completo: true,
        estado: true,
        campania: true,
        createdAt: true,
        flag_precalificacion_completada_fecha: true,
        flag_precalificacion_en_revision_fecha: true,
        fecha_fin_gestion: true,
        sector: true,
        resultado_evaluacion_equifax_tiempo: true,
        tiempo_llenado_evaluacion2: true,
        tiempo_creacion_gestion2: true,
        tiempo_de_revision_de_complementos2: true,
        tiempo_rectificaciones_contrato: true,
        tiempo_rectificaciones_documentos: true,
        tiempo_rectificaciones_referencias: true,
        tiempo_compromiso_pago_contrato: true,
        tiempo_compromiso_pago_documentos: true,
        tiempo_compromiso_pago_referencias: true,
        tiempo_total_rectificacion: true,
        tiempo_total_verificacion2: true,
        tiempo_total_aprobacion: true,
        tiempo_transcurrido_total: true,
        eventos: true,
        flag_precalificacion_eliminada_motivo: true,
      },
    };
  },
  computed: {
    modalFechas: {
      get() {
        return this.$store.state.modalFechas;
      },
      set(value) {
        this.$store.dispatch('setModalFechas', value);
      }
    },
    dialogVarSelectedRangueFecha: {
      get() {
        return this.$store.state.dialogVarSelectedRangueFecha;
      },
      set(value) {
        this.$store.dispatch('setDialogVarSelectedRangueFecha', value);
      }
    },
    selectedRangueFecha() {
      return this.$store.state.selectedRangueFecha;
    },
    disabledFecha() {
      return this.$store.state.disabledFecha;
    },
    ...mapGetters([
      'getFirstDay',
      'getLastDay',
    ]),
    filteredHeaders() {
      return this.headers.filter((header) => this.filterConfig[header.value]);
    },
    isFilterChanged() {
      return Object.values(this.filters).some((filter) => filter !== '');
    },
  },
  watch: {
    options: {
      // eslint-disable-next-line no-unused-vars
      handler(newValue) {
        this.main();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    resumirContrato(comrpomisos_de_pago) {
      let compromisos = [];

      for (let index = 0; index < comrpomisos_de_pago.length; index++) {
        const compromiso = comrpomisos_de_pago[index];

        if (compromiso.STATUS == 1) {
          compromiso.estado = 'Pendiente de aprobar';
        }
        if (compromiso.STATUS == 2) {
          compromiso.estado = 'Aprobado';
        }

        compromiso.fecha_creacion = this.fnGetDate(compromiso.createdAt);

        compromisos.push({ id: compromiso.id, comentario: compromiso.comentario, estado: compromiso.estado, fecha_creacion: compromiso.fecha_creacion });

        console.log(compromisos, 'compromisos');
      }

      return compromisos;
    },
    formatResumenContrato(resumen) {
      return resumen.map(parte =>
        `${parte.id}: ${parte.comentario} - ${parte.estado} - ${parte.fecha_creacion}`
      ).join('\n');
    },
    formatResumenContratoHTML(resumen) {
      return resumen.map(parte =>
        `<div style="font-size: 10px;">${parte.id}: ${parte.comentario} <br> <strong>${parte.estado}</strong> - ${parte.fecha_creacion}</div>`
      ).join('');
    },
    async exportToPDF() {
      this.loading = true;
      try {
        // Obtener todos los registros
        const allRecords = await this.getAllRecords();

        // Crear el documento PDF en orientación vertical
        const doc = new jsPDF('landscape', 'pt', 'a4');

        // Preparar los datos para la tabla
        const tableData = allRecords.map((record) =>
          this.headers.map((header) => {
            if (header.value === 'compromisos_de_pago') {
              if (record.compromisos_de_pago) {
                return this.formatResumenContrato(this.resumirContrato(record.compromisos_de_pago));
              } else return ''
            } else {
              return this.formatCellValue(record[header.value], header.type);
            }
          }
          )
        );

        // Definir las columnas
        const tableColumns = this.headers.map((header) => ({
          header: header.text,
          dataKey: header.value,
        }));

        // Calcular el ancho de página disponible
        const pageWidth = doc.internal.pageSize.getWidth();

        // Añadir la tabla al PDF
        doc.autoTable({
          head: [tableColumns.map((col) => col.header)],
          body: tableData,
          startY: 20,
          styles: {
            fontSize: 6,
            cellPadding: 2,
          },
          headStyles: {
            fillColor: [41, 128, 185],
            textColor: 255,
            fontSize: 6,
            fontStyle: 'bold',
          },
          columnStyles: {
            0: { cellWidth: 'auto' }, // ID column
            1: { cellWidth: 'auto' }, // Adjust as needed for other columns
          },
          alternateRowStyles: { fillColor: [245, 245, 245] },
          margin: { top: 20, right: 10, bottom: 20, left: 10 },
          tableWidth: pageWidth - 20, // Full width minus margins
        });

        // Guardar el archivo PDF
        doc.save('gestiones atrasadas segun evento.pdf');
        this.loading = false;
      } catch (error) {
        console.error('Error al exportar a PDF:', error);
        this.loading = false;
        // Aquí puedes agregar un manejo de errores más robusto, como mostrar un mensaje al usuario
      }
    },

    formatCellValue(value, type) {
      if (type === 'deudor') {
        return 'deudor';
      }
      if (type === 'date') {
        return this.fnGetDateTime(value);
      }
      if (type === 'datetime') {
        return this.fnGetDateTime(value);
      }
      if (type === 'boolean') {
        return value ? 'Sí' : 'No';
      }
      // Manejar otros tipos según sea necesario
      return value;
    },
    /** fin pdf */
    async exportToExcel() {
      this.loading = true;
      try {
        let XLSX = require('xlsx');
        // Obtener todos los registros
        const allRecords = await this.getAllRecords();

        // Preparar los datos para el Excel
        const excelData = allRecords.map((record) => {
          let rowData = {};
          this.headers.forEach((header) => {
            // Usar el 'text' como nombre de columna y 'value' para obtener el dato
            if (header.value === 'compromisos_de_pago') {
              if (record.compromisos_de_pago) {
                rowData[header.text] = this.formatResumenContrato(this.resumirContrato(record.compromisos_de_pago));
              } else return ''
            } else if (header.value === 'resultado_evaluacion_equifax_tiempo') {
              // Sustituir el valor por el contenido de resultado_evaluacion_equifax_tiempo2
              rowData[header.text] = record.resultado_evaluacion_equifax_tiempo2 || this.formatCellValue(record[header.value], header.type);
            } else {
              rowData[header.text] = this.formatCellValue(record[header.value], header.type);
            }
          });
          return rowData;
        });

        // Crear una hoja de trabajo
        const ws = XLSX.utils.json_to_sheet(excelData);

        // Crear un libro de trabajo y agregar la hoja
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Registros');

        // Guardar el archivo
        XLSX.writeFile(wb, 'gestiones atrasadas segun evento.xlsx');
        this.loading = false;
      } catch (error) {
        console.error('Error al exportar a Excel:', error);
        this.loading = false;
        // Aquí puedes agregar un manejo de errores más robusto, como mostrar un mensaje al usuario
      }
    },

    async getAllRecords() {
      const totalRecords = this.totalRegistros;
      const params = this.getParams();
      params['$limit'] = totalRecords;
      params['$skip'] = 0;

      try {
        const response = await this.findGestiones({ query: params });
        console.log('todas las gestiones: ', response);
        return response.data;
      } catch (error) {
        console.error('Error al obtener todos los registros:', error);
        throw error;
      }
    },
    fnGetDate(date) {
      return date ? moment(date).format('DD-MM-YYYY') : '';
    },
    fnGetDateUTC(date) {
      return date ? moment(date).utc().format('DD-MM-YYYY') : '';
    },
    fnGetUTCDate(date) {
      return date ? moment(date).utc().format('DD-MM-YYYY') : '';
    },
    fnGetDateTime(date) {
      return date ? moment(date).format('DD-MM-YYYY HH:mm:ss a') : '';
    },
    getYearMonth(dateString) {
      // Parse the date string to a Date object
      const date = new Date(dateString);

      // Extract the year and month
      const year = date.getFullYear();
      // Months are zero-indexed, so add 1 and pad with zero if necessary
      const month = String(date.getMonth() + 1).padStart(2, '0');

      // Concatenate year and month
      return `${year}${month}`;
    },
    //
    ...mapActions('GestionesAtrasadasSegunEvento', {
      findGestiones: 'find',
      createGestiones: 'create',
      patchGestiones: 'patch',
    }),
    ...mapActions([
      'setModalFechas',
      'setDialogVarSelectedRangueFecha',
      'saveDateRange',
    ]),
    /**paginacion */
    handlePageChange(value) {
      this.page = value;
      this.main();
    },
    handlePageSizeChange(size) {
      this.pageSize = size;
      this.page = 1;
      this.main();
    },
    /**paginacion fin */
    getParams() {
      const params = {};
      params['$limit'] = this.pageSize;
      params['$skip'] = (this.page - 1) * this.pageSize;

      /**fechas */
      /** */
      params['createdAt'] = {
        $gte: this.getFirstDay,
        $lte: this.getLastDay,
      };
      /** */
      /**fechas */
      // params['$or'] = [
      //   { flag_precalificacion_en_revision: 1 },
      //   { flag_precalificacion_con_pendientes: 1 },
      //   { flag_precalificacion_con_rectificacion: 1 },
      //   { flag_precalificacion_con_compromiso_de_pago: 1 },
      // ];

      // params['flag_precalificacion_listo_para_aprobacion'] = { $eq: null };
      // params['flag_precalificacion_concluidas'] = { $eq: null };
      // params['flag_precalificacion_cancelada'] = { $eq: null };
      /** */

      Object.keys(this.filters).forEach((key) => {
        let filterValue = this.filters[key];
        if (!filterValue) return;

        const header = this.headers.find((h) => h.value === key);
        if (!header) return;

        if (header.type === 'string' && !header.multi) {
          // Trim leading and trailing spaces
          filterValue = filterValue.trim();
          params[key] = { $like: `%${filterValue}%` };
        } else if (header.type === 'integer') {
          params[key] = filterValue;
        } else if (header.type === 'boolean') {
          params[key] = filterValue;
        } else if (header.type === 'date') {
          filterValue = filterValue.trim();

          let split_filterValue = filterValue.split('-');
          var firstDay = new Date(split_filterValue[2], split_filterValue[1] - 1, split_filterValue[0], 0, 0, 0);
          var lastDay = new Date(split_filterValue[2], split_filterValue[1] - 1, split_filterValue[0], 23, 59, 59);


          params[key] = {
            $gte: firstDay,
            $lte: lastDay,
          };

        }
        // Add more conditions for other types like 'betweendate'
      });
      /** */
      if (
        this.options.sortBy &&
        this.options.sortBy.length === 1 &&
        this.options.sortDesc.length === 1
      ) {
        let sorting = {};
        let flag = this.options.sortDesc[0] ? -1 : 1;
        sorting[this.options.sortBy[0].toString()] = flag;
        params['$sort'] = sorting;
      } else {
        params['$sort'] = { id: -1 };
      }

      return params;
    },
    /** */
    main() {
      this.findGestiones({ query: this.getParams() }).then((r) => {
        this.items = r.data;
        this.totalRegistros = r.total;
        this.totalPages = Math.ceil(
          parseInt(r.total) / parseInt(this.pageSize)
        );
      });
    },
    /** */
    applyFilters() {
      this.page = 1;
      this.main();
      // Function to apply filters and fetch data
      // eslint-disable-next-line no-unused-vars
      const params = this.getParams();
      // Use the params to fetch data from Feathers service
    },
  },
  mounted() {
    this.main();
    /** */
    const { Gestiones } = this.$FeathersVuex.api;
    Gestiones.on('created', () => {
      this.main();
    });
    Gestiones.on('patched', () => {
      this.main();
    });
  },
};
</script>
